import { render, staticRenderFns } from "./attract.vue?vue&type=template&id=46387c16&scoped=true"
import script from "./attract.vue?vue&type=script&lang=js"
export * from "./attract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46387c16",
  null
  
)

export default component.exports